import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectBuildingStageInfo, selectBuildingStageXpAmount, } from "../../../../selectors/selectExistingBuildingInfo";
import { BuildingStateType } from "../../../../utils/network/generated/protoTypes";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionAddPelletsAnimations } from "../../../animation/actionPelletAnimations";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { TypeActionBuildings } from "../actionBuildings";
export var epicBuildingAddConstructionPellets = function (action$) {
    return action$.pipe(ofType(TypeActionBuildings.AddPellets), filter(function (action) {
        return action.building.proto.state === BuildingStateType.UPGRADING ||
            action.building.proto.state === BuildingStateType.CONSTRUCTING;
    }), switchMap(function (action) {
        var building = action.building;
        var origin = utilBuildings.getCenterPositionMinSquareGlobal(building);
        var stage = building.proto.stage || 1;
        if (building.proto.state === BuildingStateType.CONSTRUCTING) {
            stage -= 1;
        }
        var buildingInfo = selectBuildingStageInfo(building, stage);
        var workers = Long.fromValue(buildingInfo.workers || 0);
        var happiness = Long.fromValue(buildingInfo.happiness || 0);
        var xp = selectBuildingStageXpAmount(building, stage);
        if (stage > 0) {
            var previousStageBuildingInfo = selectBuildingStageInfo(building, stage - 1);
            workers = workers.subtract(Long.fromValue(previousStageBuildingInfo.workers || 0));
            happiness = happiness.subtract(Long.fromValue(previousStageBuildingInfo.happiness || 0));
        }
        if (Long.ZERO.greaterThan(workers)) {
            workers = Long.ZERO;
        }
        var rewardPellets = [
            {
                amount: workers,
                icon: IdIcon.WorkersIcn,
            },
            {
                amount: happiness,
                icon: IdIcon.HappinessPositiveIcn,
            },
            {
                amount: xp,
                icon: IdIcon.XpIcn,
            },
        ];
        return of(actionAddPelletsAnimations(building.proto.id, rewardPellets, origin));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingAddConstructionPellets.ts
// module id = 2042
// module chunks = 3